<template>
  <div>
    <div class="poptxt-wrap" style="display: block">
      <p class="text_msg" v-if="textInfo[textIndex]" v-html="textInfo[textIndex][0]"></p>
      <div class="tips-closetxt" style="z-index: 9999" @click="closeHot"></div>
    </div>
  </div>
</template>

<script>
import textData from "../utils/textData";
export default {
  props: {
    textIndex: "",
  },
  data() {
    return {
      textInfo: "",
    };
  },
  methods: {
    closeHot() {
      this.$emit("closeHot", false);
    },
  },
  mounted() {
    this.textInfo = textData;
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/tour.css");
</style>